import socketConfig from "../../../config/edelWebSockets/socketConfig";
import urlConfig from "../../../config/domain";

export const WS = new WebSocket(socketConfig.socketURL + ":" + socketConfig.port);

//request format for quotes
/* empty string - "", for non mandatory field values
 * quoteType - streaming_type i.e, quote,quote2, quote3 - refer conf doc for more info
 * data - object contains user related information and array of streaming symbols
 * for which quote data is requested for
 * if vend id is 'EDEL' vendToken is not mandatory
 * userID and accType are not mandatory,
 * returns the request - created based on the parameters
 */
export const edelSocketQuoteReq = (
	quoteType: string,
	data: { vendID: string; vendToken: string; userID: string; accType: string; symbols: Array<{ symbol: string }> },
	req_type: "subscribe" | "unsubscribe" = "subscribe"
) => {
	return {
		request: {
			streaming_type: quoteType,
			data: {
				...data
			},
			formFactor: "W",
			response_format: "json",
			request_type: req_type
		},
		echo: {}
	};
};

export const edelSocketQuote1Req = (
	quoteType: string,
	data: { symbols: Array<{ symbol: string }> },
	req_type: "subscribe" | "unsubscribe" = "subscribe"
) => {
	return {
		request: {
			streaming_type: quoteType,
			data: {
				...data
			},
			formFactor: "W",
			response_format: "json",
			request_type: req_type,
			appID: urlConfig.appid
		},
		echo: {}
	};
};
